<div mat-dialog-title>
    <div class="page-title-icon">
        <span class="card-header-value dialogue-tittle"> ARE YOU SURE? </span>
        <div class="subtitle">
            Changing your consent preferences may affect how we process, analyse, or share your genetic data. Please
            review your choices carefully.
        </div>
    </div>
</div>

<mat-dialog-actions class="card-row">
    <button type="button" id="cancel_user_button" (click)="dialogRef.close('cancel')"
        mat-stroked-button>Cancel</button>
    <button type="button" id="save_my_consent_button" (click)="onConfirm()" mat-flat-button
        color="primary">Confirm</button>
</mat-dialog-actions>